module.exports = __webpack_public_path__ + "img/42.supervise.b31c10d9.svg";